import React, { useCallback, useMemo, useState } from 'react';
import { Modal } from '@adc/parallax-component-library';
import { usePartner } from 'Hooks';
import { Main } from 'Components/utility';
import i18n from 'Utilities/i18n';
const InitializationErrorPage = () => {
    const [isOpen, setIsOpen] = useState(true);
    const { handleInitializationError } = usePartner();
    const error = useMemo(() => {
        return {
            title: '',
            message: 'Global.modals.errorCommunicatingServer.body',
        };
    }, []);
    const onClose = useCallback(() => {
        setIsOpen(false);
        handleInitializationError();
    }, [handleInitializationError]);
    return (React.createElement(Main, null,
        React.createElement(Modal, { isOpen: isOpen, header: i18n.t(error.title), details: i18n.t(error.message), primaryAction: {
                label: i18n.t('Global.microcopy.common.okCap'),
                onPress: onClose,
            } })));
};
export default InitializationErrorPage;
